export default {
    money: 'Payment',
    product: 'Product',
    affiliate: 'Commission'
};
